/**
 * Labstep
 *
 * @module components/ProtocolValue/Variable/Action/SetItems/Container
 * @desc ProtocolValue Variable Action Set Items Container
 */

import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { ProtocolCondition } from 'labstep-web/models/protocol-condition.model';
import { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import type React from 'react';
import type { IProtocolValueVariableActionSetItemsContainerProps } from './types';

export const ProtocolValueVariableActionSetItemsContainer: React.FC<
  IProtocolValueVariableActionSetItemsContainerProps
> = ({ children }) => (
  <EntityUpdateContainer
    batch
    entityName={ProtocolValue.entityName}
    optimistic
  >
    {({
      update: updateProtocolValue,
      status: updateProtocolValueStatus,
    }): React.ReactElement => (
      <EntityCreateContainer
        batch
        entityName={ProtocolCondition.entityName}
        optimistic
      >
        {({
          create: createProtocolCondition,
          status: createProtocolConditionStatus,
        }): React.ReactElement => (
          <EntityCreateContainer
            batch
            entityName={ProtocolValue.entityName}
            optimistic
          >
            {({
              create: createProtocolValue,
              status: createProtocolValueStatus,
            }) => {
              const disabled = [
                createProtocolConditionStatus,
                createProtocolValueStatus,
                updateProtocolValueStatus,
              ].some((s) => s?.isFetching);
              return children({
                createProtocolValue,
                createProtocolCondition,
                updateProtocolValue,
                disabled,
              });
            }}
          </EntityCreateContainer>
        )}
      </EntityCreateContainer>
    )}
  </EntityUpdateContainer>
);
